import { FC, useState } from "react"
import { Dialog } from 'primereact/dialog';

import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputText } from "primereact/inputtext";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { TfiComment } from "react-icons/tfi";
import { Tooltip } from "primereact/tooltip";
import { Avatar } from "primereact/avatar";
import { Calendar } from "primereact/calendar";
import { HiCollection } from "react-icons/hi";
import { catchResponse, getWeekNumberMoment } from "../../../../../utils/helperFunctions";
import moment from "moment";
import { setStockPilingShutdown } from "../../../../../services/scenario-service";
import { error, success } from "../../../../../utils/notifications";
import { FiCommand } from "react-icons/fi";

export const AcopioModal:FC<any> = (props):JSX.Element => {

    const {  visible, handleClose, id, setFlagChangeScenario, flagChangeScenario } = props 

    const [dateFrom, setDateFrom] = useState<any>(null);

    const [dateTo, setDateTo] = useState<any>(null);

    const [loadingStockPiling, setLoadingStockPiling] = useState<boolean>(false)

    const handleCloseModal = () => {
        setDateFrom(null)
        setDateTo(null)
        handleClose()
    }

    const handleAddStockPilingShutdown = async() => {
        try {
            setLoadingStockPiling(true)
            let body = {
                id_scenario: id,
                date_from: moment(dateFrom).format('DD/MM/YYYY'),
                week_from: getWeekNumberMoment(moment(dateFrom).format('DD/MM/YYYY')),
                date_to: moment(dateTo).format('DD/MM/YYYY'),
                week_to: getWeekNumberMoment(moment(dateTo).format('DD/MM/YYYY'))
              }
            const res = await setStockPilingShutdown(body)
            if(res.status === 200) {
                const {code, message} = res.data
                if(code === 200) {
                    success(message)
                    setFlagChangeScenario(!flagChangeScenario)
                    handleCloseModal()
                } else {
                    error(message)
                }
                setLoadingStockPiling(false)
            } else {
                error("Error implementando el acopio")
                setLoadingStockPiling(false)
            }

        } catch(err:any) {
            catchResponse(err)
            setLoadingStockPiling(false)
        }
    }



    const header = () => {
        return (
            <span>Ajustes de Acopio</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button severity={'success'} disabled={!dateFrom || !dateTo || loadingStockPiling} label="Añadir Acopio" icon={loadingStockPiling? <FiCommand className="loading-icon" style={{fontSize:17,marginRight:'1rem',color:'#22C55E'}} /> :<HiCollection style={{fontSize:17,marginRight:'1rem'}} />}  onClick={handleAddStockPilingShutdown} outlined  />
                <Button severity={'danger'} disabled={loadingStockPiling} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleCloseModal} />
            </div>
        )
    }


   

    return (
        <div className="card flex justify-content-center">
            
            <Dialog className={"edit-modal-dialog-base"} header={header} visible={visible} style={window.screen.width > 1900? { width: '25vw',height:'45vh' } : { width: '27vw',height:'60vh' } } footer={footer} onHide={handleCloseModal}>
                <div style={{minHeight:85,display:'flex',justifyContent:'space-around',alignItems:'center',padding:'1rem',flexDirection:'column',height:'100%'}}>
                    <div className="card flex justify-content-center ajustes-modal" style={{display:'flex',flexDirection:'column'}}>
                        <label htmlFor="from" style={{fontWeight:'bold'}}>Fecha Inicio</label>
                        <Calendar locale="es" dateFormat="d/m/yy" id="from" value={dateFrom} onChange={(e:any) => setDateFrom(e.value)} showIcon />
                        <small id="from-help">
                            Introduce la fecha de inicio del imprevisto.
                        </small>
                    </div>

                    <div className="card flex justify-content-center ajustes-modal" style={{display:'flex',flexDirection:'column'}}>
                        <label htmlFor="To" style={{fontWeight:'bold'}}>Fecha Fin</label>
                        <Calendar locale="es" dateFormat="d/m/yy" id="To" disabled={dateFrom === null} minDate={dateFrom} value={dateTo} onChange={(e:any) => setDateTo(e.value)} showIcon />
                        <small id="from-help">
                            Introduce la fecha de fin del imprevisto.
                        </small>
                    </div>
                </div>
                
            </Dialog>
        </div>
    )
}